import React from "react";
import "./whatsappButton.css";

function WhatsAppButton() {
  return (
    <>
      <div className="whatsapp_container">
        <a href="https://wa.me/542612565651" target={"_blank"}>
          <i className="fa-brands fa-whatsapp"></i>
        </a>
      </div>
    </>
  );
}

export default WhatsAppButton;
